import { configureStore } from "@reduxjs/toolkit";
import manifestoReducer from "../features/manifestoSlice";

export const store = configureStore({
    reducer: {
        manifesto: manifestoReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;